class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      toggleLoader("show");
      event.preventDefault();

      const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
      const variantId = this.dataset.variantId;
      const productUrl = this.dataset.productUrl;
      const productId = this.dataset.productId;

      const giftCardTitle = productUrl?.toLowerCase().replaceAll(" ", "").replaceAll("-", "");
      const isGiftCard = giftCardTitle ? giftCardTitle?.includes("giftcard") : false;
      const quantityAfterRemoving = this.dataset.quantity || 0;
      cartItems.updateQuantity(
        this.dataset.index,
        quantityAfterRemoving,
        "remove",
        variantId,
        isGiftCard,
        this.dataset.key,
      );
      if (!isGiftCard) {
        processDeletingItem({
          epi: variantId,
          empi: productId,
          du: productUrl,
        });
      }
      toggleCartLoader("hide");
      toggleLoader("hide");
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    // this.lineItemStatusElement =
    //   document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
    this.soldOutItems = document.querySelectorAll("[data-sold-out-item]");

    if (this.soldOutItems) {
      this.removeSoldOutItemPrices();
    }

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === "cart-items") {
        this.onUpdateSWYMList(event);
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    const target = event.target;
    const isGiftCard = target.dataset.productType === "gift-card";
    this.updateQuantity(
      target.dataset.index,
      Number(target.value),
      document.activeElement.getAttribute("name"),
      target.dataset.quantityVariantId || target.dataset.variantId,
      isGiftCard,
      isGiftCard ? target.dataset.lineKey : null,
    );
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}/?sections=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const selectors = [".cart-drawer__items", ".cart-drawer__footer"];

          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.innerHTML = sourceElement.innerHTML;
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}/?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const sourceQty = html.querySelector("cart-items");
          if (sourceQty) {
            this.innerHTML = sourceQty.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  onUpdateSWYMList(pubSubData) {
    if (!pubSubData?.variantId || !pubSubData?.cartData) return;

    const updatedProduct = pubSubData.cartData.items.find((item) => item.variant_id == pubSubData.variantId);

    if (!updatedProduct) return;

    const product = {
      epi: pubSubData.variantId,
      empi: updatedProduct.product_id,
      du: pubSubData.productSwymURL,
      qty: updatedProduct.quantity,
    };
    // NOTE: We are currently not persisting gift cards
    let isGiftCard = false;
    if (pubSubData?.productSwymURL) {
      const giftCardTitle = pubSubData.productSwymURL?.toLowerCase().replaceAll(" ", "").replaceAll("-", "");
      isGiftCard = giftCardTitle ? giftCardTitle?.includes("giftcard") : false;
    }
    if (!pubSubData?.productSwymURL && pubSubData?.variantId) {
      const prodFromItems = pubSubData.cartData.items.find((item) => item.variant_id == pubSubData.variantId);
      isGiftCard = prodFromItems.handle.toLowerCase() === "fashionphile-egift-card-10001";
    }
    const persistentCartId = window.persistent_cart_id;

    if (!persistentCartId || isGiftCard) return;

    const onSwymUpdateQuantityCallback = (swat) => {
      if (!swat) return;

      swymCartItemUpdateCallback({ lid: persistentCartId, swat, product });
    };

    window.SwymCallbacks.push(onSwymUpdateQuantityCallback);
  }

  /**
   * Used in Shopify's Sections Rendering API: https://shopify.dev/docs/api/ajax/section-rendering
   *
   * Max number of sections to fetch is 5. Anymore after will be ignored.
   *
   * @returns {array}
   */
  getSectionsToRender() {
    return [
      {
        id: "main-cart",
        section: document.getElementById("main-cart")?.dataset.id,
        selector: "#main-cart",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".js-contents",
      },
      {
        id: "fp-header-icons",
        section: document.getElementById("main-header")?.dataset.id,
        selector: "#cart-icon-bubble",
      },
    ];
  }

  async getCartItems() {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) {
        throw new Error(`Cart API Error: ${res.status}`);
      }
      const cart = await res.json();
      if (!cart || !cart.items || cart.items.length === 0) {
        return null;
      }
      return cart.items;
    } catch (err) {
      console.error("Error fetching cart:", err);
      captureErrorWithScope(err, {
        area: "cart",
        method: "getCartItems",
      });
      return null;
    }
  }

  async updateQuantity(line, quantity, name, variantId, isGiftCard, key = null) {
    if (name === "remove" && !isGiftCard) {
      const cartItems = await this.getCartItems();

      if (cartItems?.length) {
        const itemInCart = cartItems.find((item) => item.id === parseInt(variantId, 10));
        const alreadyDeleted = !itemInCart || itemInCart.quantity === 0;
        if (alreadyDeleted) {
          // probably deleted in another tab
          // just remove from DOM
          const cartItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (cartItem) {
            cartItem.remove();
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-items",
            cartData: { item_count: 0, sections: {} },
            variantId: variantId,
          });
          return;
        }
      }
    }

    this.enableLoading(line);

    const body = JSON.stringify({
      id: isGiftCard && key ? key : variantId,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`) ||
          document.querySelector(`#fp-cart__quantity-selector-index-${line}`);
        const items = document.querySelectorAll(".cart-item");
        const productSwymURL = quantityElement?.getAttribute("data-product-url") ?? null;

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          // this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter) cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

          if (!elementToReplace) return; //skip to the next element

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = "";
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement?.value)) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace("[quantity]", updatedValue);
          }
        }
        // this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector(".drawer__inner-empty"), cartDrawerWrapper.querySelector("a"));
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
          productSwymURL: productSwymURL,
        });
      })
      .catch((err) => {
        console.error("Error updating cart:", err);
        this.querySelectorAll(".loading__spinner").forEach((overlay) => overlay.classList.add("hidden--important"));
        const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        toggleCartLoader("hide");
      });
  }

  // updateLiveRegions(line, message) {
  //   const lineItemError =
  //     document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
  //   if (lineItemError) lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

  //   this.lineItemStatusElement.setAttribute("aria-hidden", true);

  //   const cartStatus =
  //     document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
  //   cartStatus.setAttribute("aria-hidden", false);

  //   setTimeout(() => {
  //     cartStatus.setAttribute("aria-hidden", true);
  //   }, 1000);
  // }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden--important"),
    );

    document.activeElement.blur();
    // this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden--important"));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add("hidden--important"));
  }

  removeSoldOutItemPrices() {
    const currency = document.querySelector("#cart-currency")?.dataset.value ?? "USD";

    const totals = {
      subtotal: {
        el: document.querySelector("#cart-subtotal"),
        updatedValue: this.convertToNumber(document.querySelector("#cart-subtotal")?.dataset.value),
      },
      discount: {
        el: document.querySelector("#cart-total-discounts"),
        updatedValue: this.convertToNumber(document.querySelector("#cart-total-discounts")?.dataset.value),
      },
      estimatedTotal: {
        el: document.querySelector("#cart-estimated-total"),
        updatedValue: this.convertToNumber(document.querySelector("#cart-estimated-total")?.dataset.value),
      },
    };

    Array.from(this.soldOutItems).forEach((item) => {
      const itemData = JSON.parse(item.dataset.soldOutItem);
      if (!itemData) return;

      const originalPrice = this.convertToNumber(itemData.originalPrice);
      const totalDiscount = this.convertToNumber(itemData.totalDiscount);
      const finalPrice = this.convertToNumber(itemData.finalPrice);

      totals.subtotal.updatedValue -= originalPrice;
      totals.discount.updatedValue -= totalDiscount;
      totals.estimatedTotal.updatedValue -= finalPrice;
    });

    Object.values(totals).forEach(({ el, updatedValue }) => {
      if (el) {
        this.updateOrderSummaryLine(el, this.formatAsCurrency(updatedValue, currency));
      }
    });
  }

  convertToNumber(numString) {
    const numericValue = parseFloat(numString?.replace(/[^0-9.]/g, "")); // Keep decimal points for float values
    return isNaN(numericValue) ? 0 : numericValue; // Ensure fallback to 0
  }

  formatAsCurrency(num, currency, locale = undefined) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      trailingZeroDisplay: "stripIfInteger",
      minimumFractionDigits: 2,
    }).format(num);
  }

  updateOrderSummaryLine(el, text) {
    el.innerText = text;
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}

document.addEventListener("DOMContentLoaded", function () {
  var itemCountSpan = document.getElementById("CartDrawer-ItemCount");
  var removeButtons = document.querySelectorAll("cart-remove-button button");
  var originalCount = null;
  if (itemCountSpan) {
    // Extract the count from the span's text (assumes count is in the text)
    var match = itemCountSpan.textContent.match(/\d+/);
    if (match) {
      originalCount = parseInt(match[0], 10);
    }
  }
  removeButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (itemCountSpan && originalCount && originalCount > 0) {
        var newCount = originalCount - 1;
        // Replace the first number in the string with the new count
        itemCountSpan.textContent = itemCountSpan.textContent.replace(/\d+/, newCount);
        // Prevent further decrements until cart updates
        originalCount = null;
      }
    });
  });
});
